import React from 'react';
import { Route, Routes } from 'react-router';

import { ContactDetailScreen } from './contact-detail.screen';
import { PagePlaceholder } from '../../components/page-placeholder/page-placeholder';

import styles from './contact-detail.page.module.scss';
export const ContactDetailsPage: React.FC = () => (
  <div className={styles['container']}>
    <Routes>
      <Route path="/:contactId/*" element={<ContactDetailScreen />} />

      <Route
        path="/"
        element={
          <div className={styles['empty-placeholder-wrapper']}>
            <PagePlaceholder
              backgroundImgUrl={'/images/default-background.svg'}
              description="Select contact to view"
            />
          </div>
        }
      />
    </Routes>
  </div>
);
